import { render, staticRenderFns } from "./GetBlacklistCustom.vue?vue&type=template&id=27fa3dda&"
import script from "./GetBlacklistCustom.vue?vue&type=script&lang=js&"
export * from "./GetBlacklistCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports